import React, { Component } from 'react'
import Errors from './Errors/Errors';

import 'HELPDESK/Components/QueryDetails/AddRequestModal/ProductCustomization/productcustomization.css';
import Enhancements from './Enhancements/Enhancements';
export class ProductCustomization extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // currentRequest: {},
            // currentClientResponse: {},
            // currentQueryRequestId: '',
            productCustomizationFeature: [
                { id: 1, customizationTypeName: "Enhancements", value: <Enhancements /> },
                { id: 2, customizationTypeName: "Errors", value: <Errors /> }

            ],
            currentCustomization: this.getInitialSrType(),
            selectedModuletab: this.props.selectedModuleName,
            moduleId: this.props.selectedModuleId,
        }
    }
    getInitialSrType() {
        const { selectedQueryType } = this.props;

        if (selectedQueryType === "errors") {
            return "Errors";
        }

        return "Enhancements";
    }
    handleTypeCustomization = (customizationType) => {
        this.setState({ currentCustomization: customizationType })


    }
    render() {
        return (

            <div className='customization-enhancements'>
                <span className='vm_custom_body4 enhancement-text-wrap' >
                    <span style={{ fontWeight: 'bold', color: '#000000' }}>Please Note <span style={{ color: 'red' }}>*</span> :
                    </span>
                    {/* if serviceRequestId is through currentClientResponse  show it s it and give generic message othere wise show below meeesage*/}
                    {
                        this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 ?
                            `Your Service Request is being raised under the Parent ID ${Object.values(this.props.currentClientResponse)[0].serviceRequestId}.
The request will now proceed through the GoProcess workflow, moving unit by unit until it is resolved.`
                            :
                            `The average timeframe for free customizations is between 4 to 8 months, depending on the complexity and specific requirements. Timelines may vary from case to case.
                    For clients requiring urgent or prioritized customization, we offer a paid service with dedicated resource allocation to ensure faster delivery.
                    A detailed quotation will be shared based on the scope and effort required for the requested enhancements.`}
                </span>
                <p className='product-customization-type vm_custom_body1'>Product Customization Type</p>

                <div className="customization-tabs">
                    {/* Case 1: If no queryType -> show all tabs */}
                    {!this.props.selectedQueryType &&
                        this.state.productCustomizationFeature.map((customization) => (
                            <p
                                key={customization.id}
                                className={`vm_custom_subtitle5 customization-tab ${customization.customizationTypeName === this.state.currentCustomization
                                    ? "active"
                                    : ""
                                    }`}
                                onClick={() =>
                                    this.handleTypeCustomization(customization.customizationTypeName)
                                }
                            >
                                {customization.customizationTypeName}
                            </p>
                        ))}

                    {/* Case 2: If queryType matches -> show only that tab */}
                    {this.props.selectedQueryType &&
                        this.state.productCustomizationFeature
                            .filter(
                                (c) =>
                                    c.customizationTypeName.toLowerCase() ===
                                    this.props.selectedQueryType.toLowerCase()
                            )
                            .map((customization) => (
                                <p
                                    key={customization.id}
                                    className={`vm_custom_subtitle5 customization-tab ${customization.customizationTypeName ===
                                        this.state.currentCustomization
                                        ? "active"
                                        : ""
                                        }`}
                                    onClick={() =>
                                        this.handleTypeCustomization(customization.customizationTypeName)
                                    }
                                >
                                    {customization.customizationTypeName}
                                </p>
                            ))}
                </div>



                <>
                    {
                        this.state.currentCustomization === 'Errors' && <Errors
                            currentClientResponse={this.props.currentClientResponse}
                            onCloseModal={this.props.onCloseModal}
                            selectedModuletab={this.props.selectedModuleName}
                            moduleId={this.props.selectedModuleId}
                            selectedModuleName={this.props.selectedModuleName}
                            selectedQueryType={this.props.selectedQueryType}
                        />

                    }
                    {/* {
                        this.state.currentCustomization === 'Enhancements' && <EnhancementsCustomization
                            onCloseModal={this.props.onCloseModal}
                            selectedModuletab={this.props.selectedModuleName}
                            moduleId= {this.props.selectedModuleId}
                        />

                    } */}
                    {
                        this.state.currentCustomization === 'Enhancements' && <Enhancements
                            currentClientResponse={this.props.currentClientResponse}
                            onCloseModal={this.props.onCloseModal}
                            selectedModuletab={this.props.selectedModuleName}
                            moduleId={this.props.selectedModuleId}
                            selectedModuleName={this.props.selectedModuleName}
                            selectedQueryType={this.props.selectedQueryType}
                        />

                    }



                </>



            </div>


        )
    }
}

export default ProductCustomization
